import { useCallback } from 'react';
import useWfRecoveryRepo, {
  WfInformationStatusParametersBody,
  WfFloodPhotoParameters,
  WfPartsPhotoParameters,
} from '../repository/WfRecoveryRepo';

function useWfRecoveryService() {
  const repo = useWfRecoveryRepo();

  const registerWorkplaceInformationStatus = useCallback(
    async (body: WfInformationStatusParametersBody) => {
      const success = await repo.postWorkplaceInformationStatusRequest(body);
      if (!success) {
        throw new Error('registerWorkplaceInformationStatus failed');
      }
    },
    [repo]
  );

  const uploadFloodPhoto = useCallback(
    async (params: WfFloodPhotoParameters) => {
      try {
        const resultId = await repo.postFloodRecoveryPhoto(params);

        if (resultId) {
          return resultId;
        }

        throw new Error('Upload flood photo failed: No ID returned');
      } catch (error) {
        console.error('Error in uploadFloodPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  const uploadPartsPhoto = useCallback(
    async (params: WfPartsPhotoParameters) => {
      try {
        const resultId = await repo.postPartsRecoveryPhoto(params);

        if (resultId) {
          return resultId;
        }

        throw new Error('Upload parts photo failed: No ID returned');
      } catch (error) {
        console.error('Error in uploadPartsPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  const fetchFloodPhoto = useCallback(
    async (photoId: string) => {
      try {
        return await repo.getFloodRecoveryPhoto(photoId);
      } catch (error) {
        console.error('Error in fetchFloodPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  const fetchPartsPhoto = useCallback(
    async (photoId: string) => {
      try {
        return await repo.getPartsRecoveryPhoto(photoId);
      } catch (error) {
        console.error('Error in fetchPartsPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  const deleteFloodPhoto = useCallback(
    async (photoId: string) => {
      try {
        return await repo.deleteFloodRecoveryPhoto(photoId);
      } catch (error) {
        console.error('Error in deleteFloodPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  const deletePartsPhoto = useCallback(
    async (photoId: string) => {
      try {
        return await repo.deletePartsRecoveryPhoto(photoId);
      } catch (error) {
        console.error('Error in deletePartsPhoto service:', error);
        throw error;
      }
    },
    [repo]
  );

  return {
    registerWorkplaceInformationStatus,
    uploadFloodPhoto,
    fetchFloodPhoto,
    deleteFloodPhoto,
    uploadPartsPhoto,
    deletePartsPhoto,
    fetchPartsPhoto,
  };
}

export default useWfRecoveryService;
